import { Button, MenuItem, Select, TextField } from "@mui/material";
import EditText from "components/editText";
import MainContainer from "layout/MainContainer";
import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

const AddDiscount = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [content, setContent] = useState("");
  return (
    <MainContainer>
      {/* <Loader isLoad={loading} /> */}
      <div className="main_title fdx">
        <div>
          <h1>{id ? "Edit Discount" : "Add Discount"}</h1>
          <p>
            <span onClick={() => navigate("/dashboard")}>Dashboard</span> -
            Manage Discount - {id ? "Edit Discount" : "Add Discount"}
          </p>
        </div>
        <div className="right_s align_right">
          <Button className="btn btn_orange" onClick={() => navigate(-1)}>
            Back
          </Button>
        </div>
      </div>

      <div className="cards">
        <form className="form">
          <div className="gap_p">
            <div className="control_group w_50">
              <label>Discount Name</label>
              <TextField
                variant="outlined"
                placeholder="Name"
                className="text_field"
                fullWidth
                hiddenLabel
                name="name"
                id="name"
                inputProps={{ maxLength: 80 }}
                // value={formik.values.name}
                // onChange={(val) => {
                //   if (val.target.value === " " || val.target.value === ".") {
                //   } else {
                //     formik.handleChange(val);
                //   }
                // }}
                // onBlur={formik.handleBlur}
                // helperText={formik.touched.name && formik.errors.name}
              />
            </div>

            <div className="control_group w_50">
              <label>Discount Type</label>
              <Select
                fullWidth
                labelId="condition"
                name="condition"
                value={"default"}
                // onChange={formik.handleChange}
                // onBlur={formik.handleBlur}
                // error={formik.touched.condition && Boolean(formik.errors.condition)}
              >
                <MenuItem disabled value="default">
                  Type
                </MenuItem>

                <MenuItem value={1}>Student</MenuItem>
                <MenuItem value={2}>Corporate</MenuItem>
              </Select>
              {/* <FormHelperText error>{formik.touched.condition && formik.errors.condition}</FormHelperText> */}
            </div>

            <div className="control_group w_50">
              <label>Discount %</label>
              <TextField
                variant="outlined"
                placeholder="Discount"
                className="text_field"
                fullWidth
                hiddenLabel
                name="name"
                id="name"
                inputProps={{ maxLength: 80 }}
                // value={formik.values.name}
                // onChange={(val) => {
                //   if (val.target.value === " " || val.target.value === ".") {
                //   } else {
                //     formik.handleChange(val);
                //   }
                // }}
                // onBlur={formik.handleBlur}
                // helperText={formik.touched.name && formik.errors.name}
              />
            </div>

            <div className="control_group w_50">
              <label>Start Date</label>
              <TextField
                name="startDate"
                type="date"
                fullWidth
                InputLabelProps={{ shrink: true }}
                // value={formik.values.startDate}
                // inputProps={{
                //   min: new Date().toISOString().split("T")[0],
                // }}
                // onChange={(e) => {
                //   const value = e.target.value;
                //   const year = value.split("-")[0]; // Extract year
                //   if (year.length > 4) return; // Prevent input if year exceeds 4 digits
                //   formik.handleChange(e); // Update Formik state
                // }}
                // error={
                //   formik.touched.startDate &&
                //   Boolean(formik.errors.startDate)
                // }
                // helperText={
                //   formik.touched.startDate && formik.errors.startDate
                // }
              />
            </div>

            <div className="control_group w_50">
              <label>End Date</label>
              <TextField
                name="endDate"
                type="date"
                fullWidth
                InputLabelProps={{ shrink: true }}
                // value={formik.values.startDate}
                // inputProps={{
                //   min: new Date().toISOString().split("T")[0],
                // }}
                // onChange={(e) => {
                //   const value = e.target.value;
                //   const year = value.split("-")[0]; // Extract year
                //   if (year.length > 4) return; // Prevent input if year exceeds 4 digits
                //   formik.handleChange(e); // Update Formik state
                // }}
                // error={
                //   formik.touched.startDate &&
                //   Boolean(formik.errors.startDate)
                // }
                // helperText={
                //   formik.touched.startDate && formik.errors.startDate
                // }
              />
            </div>

            <div className="control_group w_100">
              <label>Description</label>
              <EditText content={content} setContent={setContent} />
            </div>
          </div>
          <div className="form_btn end">
            <Button
              className="btn btn_secondary"
              onClick={() => navigate("/manage-discount")}
            >
              {id ? "Edit Discount" : "Add Discount"}
            </Button>
          </div>
        </form>
      </div>
    </MainContainer>
  );
};

export default AddDiscount;
